import { Item } from '@react-stately/collections'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Download } from 'blaze-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Key } from 'react'
import { DownloadableFormat, downloadImageAs } from '../../convertImage'

export const DownloadButton = ({ url }: { url: string }) => {
  const handleAction = (key: Key) => {
    downloadImageAs(url, key as DownloadableFormat)
  }

  return (
    <MenuTrigger>
      <IconButton size="sm" variant="editor" icon={Download} preventFocusOnPress aria-label="Download" />
      <Menu onAction={handleAction}>
        <Item key="png">PNG</Item>
        <Item key="jpg">JPG</Item>
        <Item key="gif">GIF</Item>
      </Menu>
    </MenuTrigger>
  )
}
